import { AGENTS_DASHBOARD_BASE_URL } from "src/utils/agents-dashboard-url";

export function agentSessionTraceUrl(
  sessionId: string,
  target?: { messageId?: string; interactionId?: string },
): string {
  const url = new URL(
    `/sessions/${encodeURIComponent(sessionId)}`,
    AGENTS_DASHBOARD_BASE_URL,
  );
  if (target?.messageId) {
    url.searchParams.set("messageId", target.messageId);
  }
  if (target?.interactionId) {
    url.searchParams.set("interactionId", target.interactionId);
  }
  return url.href;
}
